import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/css/common.scss'
import '@/assets/css/pc.scss'
import '@/assets/css/sp.scss'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import AOS from 'aos'
import 'aos/dist/aos.css'


Vue.use(router)

Vue.config.productionTip = false

new Vue({
  created() {
    AOS.init({
      once: true,
      duration: 1000,
      easing: 'ease-out',
      offset: 500,
      disableMutationObserver: false
    })
  },
  render: h => h(App),
  router
}).$mount('#app')
